import { useEffect, useState } from 'react';
import cm from 'classnames';

import { TimeLabel, TimeLabelPayload } from 'components/app/app-components/time-label/time-label';
import styles from './_player-seek.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  player?: HTMLVideoElement | null;
  className?: string;
}

export const PlayerSeek = ({ player, className, ...rest }: Props) => {
  const [payload, setPayload] = useState<TimeLabelPayload>({ cssPosition: '', time: 0 });

  useEffect(() => {
    if (!player) return;
    const cb = () => {
      setPayload({
        cssPosition: (player.currentTime / player.duration) * 100 + '%',
        time: player.currentTime,
      });
    };
    cb();
    player.addEventListener('seeking', cb);
    return () => {
      player.removeEventListener('seeking', cb);
    };
  }, [player]);

  return (
    <div {...rest} className={cm(styles.PlayerSeek, className, { [styles['PlayerSeek--loading']]: !player })}>
      <div className={styles.PlayerSeek__progress} style={{ width: payload.cssPosition }} />
      <TimeLabel payload={payload} className={styles.PlayerSeek__label} enable={true} invert={true} />
    </div>
  );
};
